export const metadataConstants = {
  METADATA_REQUEST: "METADATA_REQUEST",
  METADATA_SUCCESS: "METADATA_SUCCESS",
  METADATA_FAILURE: "METADATA_FAILURE",
};

export const userConstants = {
  REGISTER_REQUEST: "REGISTER_REQUEST",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAILURE: "REGISTER_FAILURE",
  REGISTER_INVALID_FORM: "REGISTER_FORM_FAILURE",
  REGISTER_INVALID_FORM_PROFANITY: "REGISTER_INVALID_FORM_PROFANITY",
  REGISTER_INVALID_CAPTCHA: "REGISTER_INVALID_CAPTCHA",
};

export const emailConstants = {
  CHECK_EMAIL_REQUEST: "CHECK_EMAIL_REQUEST",
  CHECK_EMAIL_SUCCESS: "CHECK_EMAIL_SUCCESS",
  CHECK_EMAIL_FAILURE: "CHECK_EMAIL_FAILURE",
  CHECK_EMAIL_INACTIVE: "CHECK_EMAIL_INACTIVE",
  CHECK_EMAIL_SUPPORT: "CHECK_EMAIL_SUPPORT",
  RESET_LOGIN_STATE: "RESET_LOGIN_STATE",
};

export const verificationConstants = {
  CHECK_USER_REQUEST: "CHECK_USER_REQUEST",
  CHECK_USER_SUCCESS: "CHECK_USER_SUCCESS",
  CHECK_USER_FAILURE: "CHECK_USER_FAILURE",
};

export const resendVerifyTokenConstants = {
  RESEND_REQUEST_LOGIN: "RESEND_REQUEST_LOGIN",
  RESEND_SUCCESS_LOGIN: "RESEND_SUCCESS_LOGIN",
  RESEND_FAILURE_LOGIN: "RESEND_FAILURE_LOGIN",

  RESEND_REQUEST_TOKEN: "RESEND_REQUEST_TOKEN",
  RESEND_SUCCESS_TOKEN: "RESEND_SUCCESS_TOKEN",
  RESEND_FAILURE_TOKEN: "RESEND_FAILURE_TOKEN",
};

export const passwordConstants = {
  PASSWORD_EXPIRED: "PASSWORD_EXPIRED",
};

export const forgottenPasswordConstants = {
  INIT_PASSWORD_FORGOTTEN: "INIT_PASSWORD_FORGOTTEN",
  REQUEST_PASSWORD_FORGOTTEN: "REQUEST_PASSWORD_FORGOTTEN",
  REQUEST_PASSWORD_SUCCESS: "REQUEST_PASSWORD_SUCCESS",
  REQUEST_PASSWORD_FAILURE: "REQUEST_PASSWORD_FAILURE",
};

export const cpmConstants = {
  CPM_REQUEST: "CPM_REQUEST",
  CPM_SUCCESS: "CPM_SUCCESS",
  CPM_FAILURE: "CPM_FAILURE",
  CPM_UPDATED: "CPM_UPDATED",
  CPM_UPDATE_FAILURE: "CPM_UPDATE_FAILURE",
  CPM_UPDATE_ONCHANGE: "CPM_UPDATE_ONCHANGE",
};

export const verifyEmailConstants = {
  EMAIL_VERIFY_REQUEST: "EMAIL_VERIFY_REQUEST",
  EMAIL_VERIFY_SUCCESS: "EMAIL_VERIFY_SUCCESS",
  EMAIL_VERIFY_FAILURE: "EMAIL_VERIFY_FAILURE",
};
